export interface FlowStep {
  icon: string;
  label: string;
  detail: string;
}

export const DELIVERY_PARTNER_FLOW_META = {
  title: 'Delivery Person — Complete Flow',
  subtitle: 'Handles food, grocery, and parcel deliveries. Same partner, multiple services.',
};

/** Primary food delivery shift flow */
export const FOOD_DELIVERY_PARTNER_FLOW: FlowStep[] = [
  { icon: 'ToggleOn', label: 'Go Online', detail: 'Zone selected · GPS enabled' },
  { icon: 'Notifications', label: 'Order Assigned', detail: 'Auto-dispatch or dispatcher assign' },
  { icon: 'CheckCircle', label: 'Accept Order', detail: 'Navigate to restaurant' },
  { icon: 'Storefront', label: 'Arrive at Restaurant', detail: 'Waiting at pickup counter' },
  { icon: 'VerifiedUser', label: 'Pickup OTP', detail: 'Merchant confirms handoff' },
  { icon: 'Route', label: 'Navigate to Customer', detail: 'Live tracking on for customer' },
  { icon: 'Home', label: 'Arrive at Customer', detail: 'Delivery OTP required' },
  { icon: 'CheckCircle', label: 'Delivered', detail: 'Photo proof option' },
  { icon: 'AccountBalanceWallet', label: 'Earnings', detail: 'Per delivery fee + tip credited' },
];

/** Grocery / parcel use the same partner pipeline with different pickup labels */
export const MULTI_SERVICE_DELIVERY_TYPES = [
  { service: 'Food Delivery', slug: 'food-delivery', pickup: 'Restaurant', otp: 'Pickup + Delivery OTP' },
  { service: 'Grocery Delivery', slug: 'grocery-delivery', pickup: 'Store / Warehouse', otp: 'Handoff + Delivery OTP' },
  { service: 'Parcel / Courier', slug: 'courier-service', pickup: 'Sender / Hub', otp: 'Pickup proof + POD' },
  { service: 'Porter / Heavy goods', slug: 'porter-service', pickup: 'Pickup location', otp: 'Pickup + delivery proof' },
];

export const DELIVERY_PARTNER_FEATURES: { step: number; label: string; path?: string }[] = [
  { step: 1, label: 'Online/Offline toggle with zone selection', path: '/my-profile' },
  { step: 2, label: 'Multi-service: food + grocery + parcel same shift' },
  { step: 3, label: 'Pickup OTP (merchant) + Delivery OTP (customer)' },
  { step: 4, label: 'Batch delivery (multiple orders same route)' },
  { step: 5, label: 'Live map navigation integrated', path: '/hubs/delivery/food-delivery/bookings' },
  { step: 6, label: 'Daily / weekly earnings summary', path: '/hubs/delivery/food-delivery/earnings' },
  { step: 7, label: 'Peak hour surge earnings', path: '/zones' },
  { step: 8, label: 'Performance badges & incentive tiers', path: '/config/masters' },
  { step: 9, label: 'SOS emergency button', path: '/my-profile' },
  { step: 10, label: 'Wallet + direct bank settlement', path: '/wallet' },
];

export interface EarningsComponent {
  component: string;
  type: string;
  note?: string;
}

export const DELIVERY_EARNINGS_STRUCTURE: EarningsComponent[] = [
  { component: 'Base Delivery Fee', type: 'Per order / per KM' },
  { component: 'Surge Bonus', type: 'Peak hour multiplier' },
  { component: 'Customer Tip', type: '100% to partner' },
  { component: 'Distance Bonus', type: 'Long distance extra' },
  { component: 'Daily Incentive', type: 'Min N orders target' },
  { component: 'Weekend Bonus', type: 'Extra per delivery' },
  { component: 'Rating Bonus', type: 'High rating reward' },
  { component: 'Referral', type: 'Refer new partner' },
];
